//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'rater',
  created () {
    this.currentValue = this.value
  },
  mounted () {
    this.updateStyle()
  },
  props: {
    max: {
      type: Number,
      default: 5
    },
    value: {
      type: Number,
      default: 0
    },
    disabled: Boolean,
    star: {
      type: String,
      default: '★'
    },
    fontSize: {
      type: Number,
      default: 25
    },
    activeStar: {
    	type: String,
    	default: ''
    },
    defaultStar: {
    	type: String,
    	default: ''
    },
    activeColor: {
      type: String,
      default: '#fc6'
    },
    margin: {
      type: Number,
      default: 2
    }    
  },
  computed: {  	
    sliceValue () {
      const _val = this.currentValue.toFixed(2).split('.')
      return _val.length === 1 ? [_val[0], 0] : _val
    },
    cutIndex () {
      return this.sliceValue[0] * 1
    },
    cutPercent () {
      return this.sliceValue[1] * 1
    },    
  },
  methods: {
  	starHtml (i) {
  		let value = this.currentValue
  		let fontSize = this.fontSize
  		let activeStar = this.activeStar
  		let defaultStar = this.defaultStar
  		
  		activeStar = activeStar==''?`<img slot="active" src="/static/img/student/star-sel.png" style="width:${fontSize}px">`:activeStar
  		defaultStar = defaultStar==''?`<img slot="default" src="/static/img/student/star-nor.png" style="width:${fontSize}px">`:defaultStar  		
  		
  		//star与自定义图片星星同时存在时  优先取图片作为星星
			if(this.star=='★'||(this.activeStar&&this.defaultStar)){
	  			return value > (i-1) ? activeStar : defaultStar 
			}
			
  		if(this.star!='★'){
  			return this.star
  		}
		
  	},
    handleClick (i, force) {
      if (!this.disabled || force) {
        if (this.currentValue === i + 1) {
          this.currentValue = i
          this.updateStyle()
        } else {
          this.currentValue = i + 1
        }
      }
    },
    updateStyle () {
      for (var j = 0; j < this.max; j++) {
        if (j <= this.currentValue - 1) {
          this.$set(this.colors, j, this.activeColor)
        } else {
          this.$set(this.colors, j, '#ccc')
        }
      }
    }
  },
  data () {
    return {
      colors: [],
      currentValue: 0
    }
  },
  watch: {
    currentValue (val) {
      this.updateStyle()
      this.$emit('input', val)
    },
    value (val) {
      this.currentValue = val
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/MyRater.vue